import React from 'react';
import NavBar from '../components/NavBar';
import Footer from '../components/Footer';
import CareersPageComponent from '../components/CareersPageComponent';

const CareersPage = () => (
  <div className="main-container">
    <NavBar />
    <CareersPageComponent />
    <Footer />
  </div>
);

export default CareersPage;
